import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz'
import {ResolutionTools} from "./ResolutionTools";


export class ResolutionTime extends ResolutionTools {


    public static getDateFromMinutes(minutes: number): Date {
        minutes = Math.floor(minutes);
        return zonedTimeToUtc(new Date(minutes * 1000 * 60), 'Europe/Berlin');
    }

    public static getDateStringFromMinutes(minutes: number): string {
        // should be YYYY-MM-DD HH:mm
        return this.getDateFromMinutes(minutes).toISOString().substring(11, 16).replace('T', ' ');
    }

    public static getMinutesForToday(): number {
        return this.getMinutesFromDate(new Date());
    }

}